import { 
  Badge,
  IconButton
} from "@mui/material";
import {
  Mic as MicIcon,
  MicOff as MicOffIcon,
  Notifications as NotificationsIcon,
  NotificationsOff as NotificationsOffIcon,
  Cancel as CancelIcon
} from '@mui/icons-material';
import { Row, Col, Progress } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { wheel_icon } from "utils/assets/images/icons";
import COLOR from "utils/constants/color";
import Meter from "./Meter";
import { find } from "lodash";
import CustomSlider from "./Slider";
import { useNoiseMeter, useTraffic } from "store/wheel/selectors";
import ResizeAndDragabble from "components/ResizeAndDraggable";
import AccordinButton from "components/AccordinButton";
import { revokeTrafficModal } from "store/wheel/actions";
import { useDispatch } from "react-redux";
import useAudioPermission from "components/hooks/useAudioPermission";
import * as Sentry from '@sentry/react';
const bellSound = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fsound%2Fbell.mp3?alt=media&token=05f67512-9a45-460b-95f3-91f1782af067`;
const BYTE_FREQ_MAX = 128;
const NOISE_NORM_DIVISOR = 6.5;
const COOLDOWN_SECONDS = 5;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 800px;
  min-height: 500px;
  // background-color: #ffffff;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0px;
  z-index: 99999999;
  position: fixed;
  cursor: default;
  left: 25%;
  border-radius: 13px;
`;
const LogoTopRow = styled.div``;
const Logo = styled.img`
  height: auto;
  width: 160px;
`;
const LogoBottomRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  color: #fff;
  font-weight: bolder;
  font-size: 24px;
  font-size: 20px;
  letter-spacing: 1px;
`;

const CloseBtn = styled.div`
  background-color: ${COLOR.PinkExam};
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  z-index: 1;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: transparent;
`;
const WheelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: transparent;
  z-index: 11;
  transition: all 1s ease 0s;
  cursor: pointer;
`;
const WheelImg = styled.img`
  height: auto;
  width: 50px;
  margin-bottom: 5px;
`;
const Note = styled.div`
  color: ${COLOR.white};
  display: block;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 16px;
`;
const NoteWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  width: 100%;
  margin-top: 12px;
`;
const NoiseMeter = ({ sharableWidget }) => {
  const dispatch = useDispatch();
  const [trafficModal] = useTraffic();
  const trafficData = trafficModal?.widget_menu ?? [];
  const filterNoiseMeter = find(
    trafficData,
    (obj) => obj?.menu === "noise_meter"
  );

  const elementRef = useRef(null);
  const containerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 270, height: 340 });
  const audioStreamRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const [noiseLevel, setNoiseLevel] = useState(0);
  const [arcRotate, setArcRotate] = useState(0);
  const [analyser, setAnalyser] = useState(null);
  const [alertCount, setAlertCount] = useState(0);
  const [isMuted, setIsMuted] = useState(true);
  const [showAccordin, setShowAccordin] = useState(true);
  const [noiseModal, invokeNoiseModal, revokeNoiseModal] = useNoiseMeter();
  const [max_noise_level, setMaxNoiseLevel] = useState(4);
  const [muteNotification, setMuteNotification] = useState(false);
  const [notificationalertCount, setNotificationAlertCount] = useState(0);
  const audioRef = useRef(null);
  const [worker, setWorker] = useState(null);
  const workerRef = useRef(null);
  const trackerWaiting = useRef(false);
  const wasRedRef = useRef(false);
  const notificationDebounceTimerRef = useRef(null);
  const cooldownFallbackTimerRef = useRef(null);
  const maxNoiseLevelRef = useRef(4);
  const muteNotificationRef = useRef(false);
  const freqBufferRef = useRef(null);
  const playSoundRef = useRef(() => {});
  const debounceUpdateNotificationCount = React.useCallback(
    (countdownTime) => {
      if (notificationDebounceTimerRef.current) {
        clearTimeout(notificationDebounceTimerRef.current);
      }
      notificationDebounceTimerRef.current = setTimeout(() => {
        setNotificationAlertCount(countdownTime);
      }, 100);
    },
    []
  );

  useEffect(() => {
    return () => {
      if (notificationDebounceTimerRef.current) {
        clearTimeout(notificationDebounceTimerRef.current);
      }
      if (cooldownFallbackTimerRef.current) {
        clearTimeout(cooldownFallbackTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    maxNoiseLevelRef.current = max_noise_level;
  }, [max_noise_level]);

  useEffect(() => {
    muteNotificationRef.current = muteNotification;
  }, [muteNotification]);

  useEffect(() => {
    workerRef.current = worker;
  }, [worker]);

  useEffect(() => {
    audioRef.current = new Audio(bellSound);
    return () => {
      const a = audioRef.current;
      if (a) {
        a.pause();
        a.src = "";
      }
      audioRef.current = null;
    };
  }, []);

  const teardownMicrophone = useCallback(() => {
    const stream = audioStreamRef.current;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      audioStreamRef.current = null;
    }
    const ctx = audioContextRef.current;
    if (ctx) {
      ctx.close().catch(() => {});
      audioContextRef.current = null;
    }
    analyserRef.current = null;
    setAnalyser(null);
  }, []);

  useEffect(() => {
    if (isMuted) {
      teardownMicrophone();
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        if (cancelled) {
          stream.getTracks().forEach((track) => track.stop());
          return;
        }
        const context = new (window.AudioContext || window.webkitAudioContext)();
        const analyserNode = context.createAnalyser();
        const source = context.createMediaStreamSource(stream);
        source.connect(analyserNode);
        analyserNode.fftSize = 512;
        analyserNode.minDecibels = -90;
        analyserNode.maxDecibels = -10;
        analyserNode.smoothingTimeConstant = 0.4;
        if (cancelled) {
          stream.getTracks().forEach((track) => track.stop());
          context.close().catch(() => {});
          return;
        }
        audioStreamRef.current = stream;
        audioContextRef.current = context;
        analyserRef.current = analyserNode;
        setAnalyser(analyserNode);
      } catch (err) {
        Sentry.captureException(`397 Error during startMicrophone: ${err}`);
      }
    })();
    return () => {
      cancelled = true;
      teardownMicrophone();
    };
  }, [isMuted, teardownMicrophone]);

  useEffect(() => {
    analyserRef.current = analyser;
    if (analyser?.frequencyBinCount) {
      freqBufferRef.current = new Uint8Array(analyser.frequencyBinCount);
    } else {
      freqBufferRef.current = null;
    }
  }, [analyser]);

  useEffect(() => {
    const isRed = Boolean(max_noise_level) && noiseLevel > max_noise_level;
    if (isRed && !wasRedRef.current) {
      setAlertCount((prev) => prev + 1);
      playSoundRef.current();
    }
    wasRedRef.current = isRed;
  }, [noiseLevel, max_noise_level]);

  useEffect(() => {
    if (isMuted) {
      wasRedRef.current = false;
    }
  }, [isMuted]);

  useEffect(() => {
    if (isMuted) {
      setNoiseLevel(0);
      setArcRotate(0);
      return undefined;
    }
    const interval = setInterval(() => {
      const node = analyserRef.current;
      const buf = freqBufferRef.current;
      if (!node || !buf || buf.length !== node.frequencyBinCount) {
        return;
      }
      node.getByteFrequencyData(buf);
      let sum = 0;
      for (let i = 0; i < buf.length; i++) {
        sum += buf[i];
      }
      const average = sum / buf.length;
      const normalizedLevel = (average / BYTE_FREQ_MAX) * 10;
      const norm = average / NOISE_NORM_DIVISOR;
      setArcRotate(normalizedLevel);
      setNoiseLevel(norm);
    }, 100);
    return () => clearInterval(interval);
  }, [isMuted]);

  useEffect(() => {
    const newWorker = new Worker(`${(import.meta.env.BASE_URL || '/').replace(/\/?$/, '/')}timeWorker.js?t=5`);
    setWorker(newWorker);
    newWorker.onmessage = (event) => {
      switch (event.data.type) {
        case "tick":
          trackerWaiting.current = true;
          debounceUpdateNotificationCount(event.data.countdownTime);
          break;
        case "done":
          if (notificationDebounceTimerRef.current) {
            clearTimeout(notificationDebounceTimerRef.current);
            notificationDebounceTimerRef.current = null;
          }
          setNotificationAlertCount(0);
          trackerWaiting.current = false;
          break;
        case "reset":
          trackerWaiting.current = false;
          debounceUpdateNotificationCount(event.data.countdownTime);
          break;
      }
    };
    return () => newWorker.terminate();
  }, []);

  const playSound = useCallback(() => {
    if (muteNotificationRef.current) {
      return;
    }
    trackerWaiting.current = true;
    if (!audioRef.current) {
      audioRef.current = new Audio(bellSound);
    }
    const bell = audioRef.current;
    if (bell) {
      bell.currentTime = 0;
      bell.play().catch(() => {});
    }
    setNotificationAlertCount(COOLDOWN_SECONDS);
    const w = workerRef.current;
    if (w) {
      w.postMessage({ command: "start", time: COOLDOWN_SECONDS });
    }
    if (cooldownFallbackTimerRef.current) {
      clearTimeout(cooldownFallbackTimerRef.current);
    }
    cooldownFallbackTimerRef.current = setTimeout(() => {
      trackerWaiting.current = false;
      setNotificationAlertCount(0);
    }, COOLDOWN_SECONDS * 1000 + 300);
  }, []);

  useEffect(() => {
    playSoundRef.current = playSound;
  }, [playSound]);

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };
  const onClose = async () => {
    await dispatch(revokeTrafficModal(filterNoiseMeter?.id));
    revokeNoiseModal();
    setNoiseLevel(0);
    setArcRotate(0);
    setAlertCount(0);
    setIsMuted(true);
  };

  const handleTouch = (event) => {
    event.preventDefault();
    onClose();
  };

  const noisePercant = (notificationalertCount / COOLDOWN_SECONDS) * 100;

  const applyWidgetDimensions = useCallback((data) => {
    const w = Number(data?.width);
    const h = Number(data?.height);
    if (!Number.isFinite(w) || !Number.isFinite(h) || w < 1 || h < 1) {
      return;
    }
    setDimensions({
      width: w,
      height: h,
      transform: data?.transform,
    });
  }, []);

  const { noAccess, noPermission,checkAudioPermission } = useAudioPermission();

  useEffect(() =>{
    if(filterNoiseMeter?.view && filterNoiseMeter?.menu === "noise_meter"){
      checkAudioPermission();
    }

  },[filterNoiseMeter])


  return (
    <>
      {filterNoiseMeter?.view && filterNoiseMeter?.menu === "noise_meter" ? (
        <div>
          <Container className="spinWheelCntnr overflow-unset">
            <div className="mainCheckList">
              <ResizeAndDragabble
                defaultValue={{
                  width: 270,
                  height: 340,
                  x: 150,
                  y: 205
                }}
                resize={applyWidgetDimensions}
                minWidth={270}
                minHeight={340}
                showAccordin={showAccordin}
                center={true}
                page={"noise_meter"}
              >
                <div
                  className="checkListTopSection maxNoiseUpr addWidgetSpc"
                  style={{
                    padding: showAccordin ? "0px" : "0px",
                    position: "relative",
                    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px",
                    height: showAccordin ? "100%" : "0px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      display: "grid",
                      placeItems: "center",
                      flexDirection: "column",
                    }}
                    ref={elementRef}
                  >
                    <div
                      style={{ marginBottom: "0px" }}
                      className="noise-cancel"
                    >
                      <CancelIcon
                        onClick={() => onClose()}
                        onTouchStart={handleTouch}
                        style={{
                          zIndex: 1,
                          marginLeft: "5px",
                          position: "absolute",
                          right: 11,
                          top: 14,
                          fontSize: 20,
                          color: "red",
                          background: "white",
                          borderRadius: 20,
                          cursor: "pointer",
                        }}
                      />
                    </div>

                    <div
                      style={{
                        fontSize: `${`clamp(21px, ${
                          dimensions.width / 17
                        }px, 100px)`}`,
                      }}
                      className={`checkListFirstTxt widgetFooterGradientOrange w-full absolute top-0  bg-blue-10 pt-17px pb-14px ${
                        showAccordin ? "br-topLeft-topRight-20px" : "br-10px"
                      } `}
                    >
                      <AccordinButton
                        open={showAccordin}
                        onClose={() => setShowAccordin((prev) => !prev)}
                      />
                      <span className="text-white text-ft12-700">
                        {" "}
                        Max Noise
                      </span>
                    </div>
                    {showAccordin && (
                      <>
                        {noAccess || noPermission ? (
                          <Warning>
                            {noPermission
                              ? "Please grant access to your microphone to ensure proper recording functionality."
                              : ""}
                            {noAccess && !noPermission
                              ? "Please connect your microphone to ensure optimal recording functionality."
                              : ""}
                          </Warning>
                        ) : (
                          <>
                            <Row
                              gutter={[10, 10]}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                marginTop: "29px",
                              }}
                            >
                              <Col
                                span={24}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Meter
                                  value={noiseLevel}
                                  arcRotate={arcRotate}
                                  height={
                                    dimensions.width > 600
                                      ? dimensions.width / 2 + 150 - 200
                                      : dimensions.width / 5 + 82
                                  }
                                  width={
                                    dimensions.width > 600
                                      ? dimensions.width / 3 + 150
                                      : dimensions.width / 5 + 150
                                  }
                                  max_value={max_noise_level}
                                />
                              </Col>
                            </Row>
                            <Row
                              className="no-drag"
                              gutter={[10, 10]}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                height: 30,
                              }}
                            >
                              <Col
                                span={24}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "column",
                                }}
                              >
                                <CustomSlider
                                  dimensions={dimensions}
                                  value={max_noise_level}
                                  onChange={setMaxNoiseLevel}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                span={24}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  justifyItems: "flex-start",
                                  alignItems: "center",
                                  gap: 24,
                                }}
                              >
                                <div style={{ position: "relative" }}>
                                  <Progress
                                    type="circle"
                                    percent={(notificationalertCount / COOLDOWN_SECONDS) * 100}
                                    size={"small"}
                                    className={"fileProgress"}
                                    showInfo={false}
                                    style={{
                                      position: "absolute",
                                      left: -4,
                                      top: -4,
                                      display: "none",
                                    }}
                                    strokeWidth={6}
                                  />
                                  <IconButton
                                    aria-label="notifications"
                                    style={{
                                      background: COLOR.white,
                                      height: `clamp(42px, ${
                                        dimensions.width / 10                                      }px, 220px)`,
                                      width: `clamp(42px, ${
                                        dimensions.width / 10
                                      }px, 220px)`,
                                      border: `3px solid #f5f5f5`,
                                      padding: "21px",
                                    }}
                                    onPointerDown={() =>
                                      setMuteNotification(!muteNotification)
                                    }
                                  >
                                    <div
                                      style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: "50%",
                                        border: `6px solid ${
                                          noisePercant === 100
                                            ? "rgb(82, 196, 26)"
                                            : "#f5f5f5"
                                        }`,
                                      }}
                                    />
                                    <Badge
                                      badgeContent={alertCount}
                                      color="secondary"
                                    >
                                      {muteNotification ? (
                                        <NotificationsOffIcon
                                          style={{
                                            color: COLOR.yellow,
                                            fontSize: `clamp(24px, ${
                                              dimensions.width / 15
                                            }px, 72px)`,
                                          }}
                                        />
                                      ) : (
                                        <NotificationsIcon
                                          style={{
                                            color: COLOR.yellow,
                                            fontSize: `clamp(24px, ${
                                              dimensions.width / 15
                                            }px, 72px)`,
                                          }}
                                        />
                                      )}
                                    </Badge>
                                  </IconButton>
                                </div>
                                <IconButton
                                  onPointerDown={toggleMute}
                                  aria-label="mute"
                                  style={{
                                    backgroundColor: isMuted
                                      ? COLOR.red
                                      : COLOR.green100,
                                    height: `clamp(42px, ${
                                      dimensions.width / 15
                                    }px, 220px)`,
                                    width: `clamp(42px, ${
                                      dimensions.width / 15
                                    }px, 220px)`,
                                  }}
                                >
                                  {isMuted ? (
                                    <MicOffIcon
                                      style={{
                                        color: COLOR.white,
                                        fontSize: `clamp(24px, ${
                                          dimensions.width / 16
                                        }px, 220px)`,
                                        width: 72,
                                      }}
                                    />
                                  ) : (
                                    <MicIcon
                                      style={{
                                        color: COLOR.white,
                                        fontSize: `clamp(24px, ${
                                          dimensions.width / 16
                                        }px, 220px)`,
                                        width: "72px",
                                      }}
                                    />
                                  )}
                                </IconButton>
                              </Col>
                            </Row>
                            <NoteWrapper>
                              <Note
                                style={{
                                  color: "#000",
                                  fontSize: `clamp(13px, ${
                                    dimensions?.width / 35
                                  }px, 40px)`,
                                  marginBottom: "0px",
                                  textAlign: "center",
                                }}
                              >
                                Sensitivity scale from 1 to 10: 1 is most
                                sensitive, 10 is least sensitive.
                              </Note>
                            </NoteWrapper>
                          </>
                        )}
                      </>
                    )}
                  </div>
                  {showAccordin && (
                    <div className="widgetFooter widgetFooterGradientOrange"><label>Widget</label></div>
                  )}
                </div>
              </ResizeAndDragabble>
            </div>
          </Container>
        </div>
      ) : null}
    </>
  );
};

export default React.memo(NoiseMeter);

export const NoiseMeterViewer = ({}) => {
  const [, invokeNoiseModal] = useNoiseMeter();
  return (
    <WheelWrapper onClick={invokeNoiseModal} className="wheelSpinImg">
      <WheelImg src={wheel_icon} />
    </WheelWrapper>
  );
};

const Warning = styled.div`
  align-items: center;
  background-color: #ff00004d;
  border: 1px dashed red;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  justify-content: center;
  padding: 16px;
  text-align: center;
  width: 93%;
  position: absolute;
`;
